import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../helpers/export'
import GeneralAnalysisService from './GeneralAnalysisService'

export const getGenericRatioHighlight = createAsyncThunk(
  'industryAnalysis/getGenericRatioHighlight',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getGenericRatioHighlight(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getIndustryRatioDetail = createAsyncThunk(
  'industryAnalysis/getIndustryRatioDetail',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getIndustryRatioDetail(params)
      if (res.success) {
        return res.data?.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getActivitiesRatioAndRisk = createAsyncThunk(
  'industryAnalysis/getActivitiesRatioAndRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getActivitiesRatioAndRisk(params)
      if (res.success) {
        return res.data?.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getActivitiesRatioAndRiskCompare = createAsyncThunk(
  'industryAnalysis/getActivitiesRatioAndRiskCompare',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getActivitiesRatioAndRiskCompare(
        params,
      )
      if (res.success) {
        return res.data?.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDistributeScoreChart = createAsyncThunk(
  'industryAnalysis/getDistributeScoreChart',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getDistributeScoreChart(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDistributeScoreCompareChart = createAsyncThunk(
  'industryAnalysis/getDistributeScoreCompareChart',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getDistributeScoreCompareChart(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCommentary = createAsyncThunk(
  'industryAnalysis/getCommentary',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getIndustryNews(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportGeneralAnalysis = createAsyncThunk(
  'industryAnalysis/exportGeneralAnalysis',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.exportGeneralAnalysis(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getPerformanMatrixChartData = createAsyncThunk(
  'industryAnalysis/getPerformanMatrixChartData',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getPerformanMatrixChartData(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getPerformanMatrixDisplayData = createAsyncThunk(
  'industryAnalysis/getPerformanMatrixDisplayData',
  async (params, { rejectWithValue }) => {
    try {
      const res = await GeneralAnalysisService.getPerformanMatrixDisplayData(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
